

import React, { memo } from 'react';
import '../styles/_indicator.scss';

function onClickIndicator(commentId, onClick) {
  return () => {
    onClick(commentId);
  };
}











function Indicator({ commentId, onClick, colour, leftPercent }) {
  const left = `calc(${leftPercent}% - 3px)`;
  const style = colour ?
  {
    left,
    backgroundColor: colour.color,
    filter: colour.brightness
  } :
  { left, opacity: 0 };

  return (
    <button
      style={style}
      type="button"
      onClick={onClickIndicator(commentId, onClick)}
      className="comment-indicator" />);


}

export default memo(Indicator);